import useAsync from "Hooks/useAsync";
import { apiGetCustomerApplicationSummary } from "./apiCustomerApplications";

type UseApiCustomerApplicationsArgs = {
	id?: string,
}

export default function useApiCustomerApplications(args: UseApiCustomerApplicationsArgs) {
	const { id } = args;
	const request = useAsync(async () => {
		if(id === undefined) return undefined;
		const { data } = await apiGetCustomerApplicationSummary(id);
		if(data === null) return undefined;
		return data;
	}, [id]);

	return request;
}